import React, { useState } from "react";
import s from "./DuelDotsLab.module.scss";

// The duel's score target in the HUD: "First to 3" over five marks, one per
// possible round, filling left to right in each round winner's colour. Five
// designs, each as the desktop rail's headline and as the phone's readout
// line; the slider plays the rounds. Linked from the Admin page.

const YOU = "#03A9F4";
const THEM = "#E91E63";
const SEQ = [YOU, THEM, YOU, THEM, YOU];
const DESIGNS = [
  { id: "A", name: "Pips", blurb: "Plain discs, 20px, lit solid with a soft glow. The quiet one." },
  { id: "B", name: "Track", blurb: "Discs on a thin rail, like stops on a line: the run to 3 reads as a path." },
  { id: "C", name: "Segments", blurb: "Five rounded bars, the placement strip's language, lit in the winner's colour." },
  { id: "D", name: "Rings", blurb: "Hollow rings; a win fills the ring and leaves a dark core, a target hit." },
  { id: "E", name: "Diamonds", blurb: "Rotated squares, a little sharper and more arcade." },
];

function Marks({ design, played, compact }: { design: string; played: number; compact: boolean }) {
  const cls = `${s.marks} ${s["d" + design]} ${compact ? s.compact : ""}`;
  return (
    <span className={cls}>
      {SEQ.map((c, i) => <i key={i} className={i < played ? s.on : ""} style={i < played ? ({ "--dot": c } as React.CSSProperties) : undefined} />)}
    </span>
  );
}

export default function DuelDotsLab() {
  const [played, setPlayed] = useState(2);
  return (
    <div className={s.lab}>
      <div className={s.bar}>
        <span className={s.barLabel}>Rounds played</span>
        <div className={s.seg}>
          {[0, 1, 2, 3, 4, 5].map((n) => <button key={n} className={`${s.segBtn} ${n === played ? s.segOn : ""}`} onClick={() => setPlayed(n)}>{n}</button>)}
        </div>
        <span className={s.hint}>you are blue, they are pink; wins alternate</span>
      </div>
      {DESIGNS.map((d) => (
        <section key={d.id} className={s.row}>
          <h2 className={s.h2}><b>{d.id}</b> {d.name} <span>{d.blurb}</span></h2>
          <div className={s.pair}>
            {/* the desktop rail's top: chip + toolbar row, then the headline */}
            <div className={s.pc}>
              <div className={s.pcTop}><span className={s.chip}>Classic</span><span className={s.tools}><i /><i /><i /><i /></span></div>
              <div className={s.pcHead}>
                <div>
                  <div className={s.label}>First to 3</div>
                  <Marks design={d.id} played={played} compact={false} />
                </div>
                <div className={s.pcSmall}><span><em>Round</em> {played + 1}</span><span><em>Alive</em> <b>2</b>/2</span></div>
              </div>
              <div className={s.pcRow}><i style={{ background: YOU }} />You</div>
              <div className={s.pcRow}><i style={{ background: THEM }} />Kurvenkönig</div>
            </div>
            {/* the phone's readout line above the arena */}
            <div className={s.phone}>
              <div className={s.readout}>
                <span><em>Round</em> {played + 1}</span>
                <span><em>Alive</em> <b>2</b>/2</span>
                <span><em>First to 3</em> <Marks design={d.id} played={played} compact /></span>
              </div>
              <span className={s.tools}><i /><i /><i /><i /></span>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
